import React, { useEffect, useState } from 'react';
import { XIcon, BellIcon, UserPlusIcon, MusicIcon, HeadphonesIcon } from 'lucide-react';
interface NotificationsPopupProps {
  onClose: () => void;
}
export const NotificationsPopup = ({
  onClose
}: NotificationsPopupProps) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center" data-id="element-412">
        <div className="bg-[#282828] rounded-lg w-full max-w-sm mx-4 overflow-hidden" data-id="element-413">
          <div className="p-4 flex items-center justify-between border-b border-white/10" data-id="element-414">
            <h2 className="font-bold text-lg" data-id="element-415">Notifications</h2>
            <button onClick={onClose} className="p-1.5 hover:bg-white/10 rounded-full transition-colors" data-id="element-416">
              <XIcon className="w-5 h-5" data-id="element-417" />
            </button>
          </div>
          <div className="max-h-[60vh] overflow-y-auto" data-id="element-418">
            <NotificationItem icon={<UserPlusIcon className="w-5 h-5 text-white" data-id="element-420" />} title="New follower" message="John Smith started following you" time="2h ago" color="bg-blue-500" data-id="element-419" />
            <NotificationItem icon={<MusicIcon className="w-5 h-5 text-white" data-id="element-422" />} title="New release" message="The Weeknd just released a new album" time="1d ago" color="bg-green-500" data-id="element-421" />
            <NotificationItem icon={<HeadphonesIcon className="w-5 h-5 text-white" data-id="element-424" />} title="Playlist update" message="Your Release Radar has been updated" time="2d ago" color="bg-purple-500" data-id="element-423" />
            <NotificationItem icon={<BellIcon className="w-5 h-5 text-white" data-id="element-426" />} title="Spotify announcement" message="New feature: Movies now available on Spotify" time="3d ago" color="bg-red-500" data-id="element-425" />
            <div className="p-4 text-center" data-id="element-427">
              <button className="text-sm text-green-500 hover:text-green-400 transition-colors" data-id="element-428">
                View all notifications
              </button>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="fixed top-16 right-8 z-50" data-id="element-429">
      <div className="bg-[#282828] rounded-lg shadow-xl w-80 overflow-hidden" data-id="element-430">
        <div className="p-4 flex items-center justify-between border-b border-white/10" data-id="element-431">
          <h2 className="font-bold text-lg" data-id="element-432">Notifications</h2>
          <button onClick={onClose} className="p-1.5 hover:bg-white/10 rounded-full transition-colors" data-id="element-433">
            <XIcon className="w-5 h-5" data-id="element-434" />
          </button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto" data-id="element-435">
          <NotificationItem icon={<UserPlusIcon className="w-5 h-5 text-white" data-id="element-437" />} title="New follower" message="John Smith started following you" time="2h ago" color="bg-blue-500" data-id="element-436" />
          <NotificationItem icon={<MusicIcon className="w-5 h-5 text-white" data-id="element-439" />} title="New release" message="The Weeknd just released a new album" time="1d ago" color="bg-green-500" data-id="element-438" />
          <NotificationItem icon={<HeadphonesIcon className="w-5 h-5 text-white" data-id="element-441" />} title="Playlist update" message="Your Release Radar has been updated" time="2d ago" color="bg-purple-500" data-id="element-440" />
          <NotificationItem icon={<BellIcon className="w-5 h-5 text-white" data-id="element-443" />} title="Spotify announcement" message="New feature: Movies now available on Spotify" time="3d ago" color="bg-red-500" data-id="element-442" />
          <div className="p-4 text-center" data-id="element-444">
            <button className="text-sm text-green-500 hover:text-green-400 transition-colors" data-id="element-445">
              View all notifications
            </button>
          </div>
        </div>
      </div>
    </div>;
};
interface NotificationItemProps {
  icon: React.ReactNode;
  title: string;
  message: string;
  time: string;
  color: string;
}
const NotificationItem = ({
  icon,
  title,
  message,
  time,
  color
}: NotificationItemProps) => <div className="p-4 border-b border-white/5 hover:bg-white/5 transition-colors cursor-pointer" data-id="element-446">
    <div className="flex" data-id="element-447">
      <div className={`${color} rounded-full p-2 mr-3`} data-id="element-448">{icon}</div>
      <div className="flex-1" data-id="element-449">
        <div className="font-medium" data-id="element-450">{title}</div>
        <div className="text-sm text-gray-300" data-id="element-451">{message}</div>
        <div className="text-xs text-gray-400 mt-1" data-id="element-452">{time}</div>
      </div>
    </div>
  </div>;